(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.bindChromeHeightObserver();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--height-header', `${height}px`);

      const announcementEl = document.querySelector('.announcement-split, .announcement-bar, #announcement-topbar');
      const announcementSection = announcementEl ? announcementEl.closest('.shopify-section') || announcementEl : null;
      const announcementHeight = announcementSection ? announcementSection.offsetHeight : 0;
      document.documentElement.style.setProperty('--height-announcementbar', `${announcementHeight}px`);
    }

    bindChromeHeightObserver() {
      if (!('ResizeObserver' in window)) return;

      this.chromeResizeObserver = new ResizeObserver(() => this.setHeaderHeight());

      if (this.header) {
        this.chromeResizeObserver.observe(this.header);
      }

      const announcementEl = document.querySelector('.announcement-split, .announcement-bar, #announcement-topbar');
      const announcementSection = announcementEl ? announcementEl.closest('.shopify-section') || announcementEl : null;
      if (announcementSection) {
        this.chromeResizeObserver.observe(announcementSection);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.chromeResizeObserver) {
        this.chromeResizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template-v2"] && !Shopify.designMode) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');
  if(typeof(getpagi) !== "undefined" && getpagi !== null){
    document.addEventListener("DOMContentLoaded", function() {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="rb-load-more-spinner" aria-hidden="true"></span> Loading...',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const steppers = document.querySelectorAll('[data-ring-builder-stepper]');
    if (!steppers.length) return;

    steppers.forEach(function (stepper) {
      const root = stepper.closest('.main-collection');
      if (!root) return;

      const buttons = Array.from(stepper.querySelectorAll('[data-step-target]'));
      const stepperNav = stepper.querySelector('.ring-builder-stepper__nav');
      const panels = Array.from(root.querySelectorAll('[data-step-panel]'));
      const browseContent = root.querySelector('[data-ring-builder-browse]');
      const stepperChangeBtn = stepper.querySelector('[data-ring-builder-change]');
      const stepOneLabel = stepper.querySelector('[data-ring-builder-step-label="1"]');
      const stepTwoLabel = stepper.querySelector('[data-ring-builder-step-label="2"]');
      const stepperChangeDiamondBtn = stepper.querySelector('[data-ring-builder-change-diamond]');
      const featuredPanel = root.querySelector('[data-ring-builder-featured]');
      const featuredDetailPanel = root.querySelector('[data-ring-builder-featured-detail]');
      const settingPreviewBody = root.querySelector('[data-ring-builder-setting-preview-body]');
      const settingBackBtn = root.querySelector('[data-ring-builder-setting-back]');

      const heroWrap = root.querySelector('[data-ring-builder-hero-wrap]');
      let currentStep = '1';
      let activeSettingProduct = null;
      let activeSettingCard = null;

      const FLOW_KEY = 'ringBuilderFlow';
      const FLOW_SETTING_FIRST = 'setting-first';
      const FLOW_DIAMOND_FIRST = 'diamond-first';
      const RING_BUILDER_BASE = (root.getAttribute('data-ring-builder-base-path') || '/collections/ring-builder').replace(/\/+$/, '');

      const getFlowPathSegment = function (flow) {
        return flow === FLOW_DIAMOND_FIRST ? 'diamonds' : 'settings';
      };

      const normalizePath = function (pathname) {
        const path = String(pathname || '').replace(/\/+$/, '');
        return path || '/';
      };

      /**
       * Legacy client-only paths. Shopify treats /diamonds and /settings as collection
       * tags and 301-redirects them on full page load — so nav menu links cannot use them.
       * Kept only so in-session history / old bookmarks can still be detected if present.
       */
      const getFlowFromPath = function (pathname) {
        const path = normalizePath(pathname || window.location.pathname);
        if (path === RING_BUILDER_BASE + '/diamonds') {
          return FLOW_DIAMOND_FIRST;
        }
        if (path === RING_BUILDER_BASE + '/settings') {
          return FLOW_SETTING_FIRST;
        }
        return null;
      };

      const getDiamondFilterUrlKeys = function () {
        if (window.RING_BUILDER_DIAMOND_FILTER_URL_KEYS) {
          return window.RING_BUILDER_DIAMOND_FILTER_URL_KEYS;
        }
        return [
          'Shape', 'PriceFrom', 'PriceTo', 'CaratFrom', 'CaratTo', 'Color', 'Cut', 'Clarity',
          'Polish', 'Symmetry', 'Fluorescence', 'Report', 'DepthFrom', 'DepthTo',
          'TableFrom', 'TableTo', 'RatioFrom', 'RatioTo', 'CertNumber', 'DiamondType',
          'ColourMode', 'FancyColor', 'FancyIntensity', 'FancyOvertone', 'Sort'
        ];
      };

      /** Keys that mean "open diamond browse" when present without an explicit flow. */
      const DIAMOND_ENTRY_PARAM_KEYS = [
        'DiamondType', 'ColourMode', 'FancyColor', 'FancyIntensity', 'FancyOvertone',
        'Color', 'Clarity', 'Cut', 'Shape', 'CertNumber'
      ];

      const urlHasDiamondEntryParams = function (params) {
        return DIAMOND_ENTRY_PARAM_KEYS.some(function (key) {
          return params.has(key);
        });
      };

      /**
       * Public / refresh-safe URLs must stay on /collections/ring-builder with ?flow=
       * (path segments /diamonds|/settings are stripped by Shopify on hard navigation).
       */
      const buildRingBuilderUrl = function (flow, step) {
        const resolvedFlow =
          flow === FLOW_DIAMOND_FIRST ? FLOW_DIAMOND_FIRST : FLOW_SETTING_FIRST;
        const path = RING_BUILDER_BASE;
        const params = new URLSearchParams();
        params.set('flow', resolvedFlow);
        if (step && String(step) !== '1') {
          params.set('step', String(step));
        }
        if (window.location.search.indexOf('_fd=0') !== -1) {
          params.set('_fd', '0');
        }
        const current = new URLSearchParams(window.location.search);
        getDiamondFilterUrlKeys().forEach(function (key) {
          const val = current.get(key);
          if (val) params.set(key, val);
        });
        // Preserve theme preview / editor query flags when present.
        ['preview_theme_id', 'pb'].forEach(function (key) {
          const val = current.get(key);
          if (val) params.set(key, val);
        });
        const qs = params.toString();
        return path + (qs ? '?' + qs : '');
      };

      let presentationMode = FLOW_SETTING_FIRST;

      const getFlow = function () {
        return presentationMode;
      };

      const isDiamondFirst = function () {
        return presentationMode === FLOW_DIAMOND_FIRST;
      };

      const setPresentation = function (mode) {
        presentationMode = mode === FLOW_DIAMOND_FIRST ? FLOW_DIAMOND_FIRST : FLOW_SETTING_FIRST;
        localStorage.setItem(FLOW_KEY, presentationMode);
        if (root) root.setAttribute('data-ring-builder-flow', presentationMode);
        if (stepper) stepper.setAttribute('data-ring-builder-flow', presentationMode);
        applyFlowPresentation();
      };

      const setFlow = setPresentation;

      const getContentForLogicalStep = function (logicalStep) {
        if (String(logicalStep) === '3') return 'complete';
        if (isDiamondFirst()) {
          return String(logicalStep) === '1' ? 'diamond' : 'setting';
        }
        return String(logicalStep) === '1' ? 'setting' : 'diamond';
      };

      const logicalToContentType = function (logicalStep) {
        if (logicalStep === '3') return 'complete';
        if (isDiamondFirst()) {
          return logicalStep === '1' ? 'diamond' : 'setting';
        }
        return logicalStep === '1' ? 'setting' : 'diamond';
      };

      const getLogicalStepForContent = function (contentType) {
        if (contentType === 'complete') return '3';
        if (isDiamondFirst()) {
          return contentType === 'diamond' ? '1' : '2';
        }
        return contentType === 'setting' ? '1' : '2';
      };

      const validateLogicalStep = function (stepTarget) {
        const selectedSetting = localStorage.getItem('ringBuilderSelectedSetting');
        const selectedDiamond = localStorage.getItem('ringBuilderSelectedDiamond');

        if (stepTarget === '3') {
          if (!selectedSetting || !selectedDiamond) {
            if (!selectedDiamond) return getLogicalStepForContent('diamond');
            if (!selectedSetting) return getLogicalStepForContent('setting');
          }
          return '3';
        }

        return stepTarget;
      };

      const stepOneText = stepper.querySelector('[data-step-target="1"] .ring-builder-stepper__text');
      const stepTwoText = stepper.querySelector('[data-step-target="2"] .ring-builder-stepper__text');
      const stepOneIcon = stepper.querySelector('[data-step-target="1"] .ring-builder-stepper__icon img');
      const stepTwoIcon = stepper.querySelector('[data-step-target="2"] .ring-builder-stepper__icon img');
      const iconSettingUrl = stepper.getAttribute('data-rb-icon-setting') || '';
      const iconDiamondUrl = stepper.getAttribute('data-rb-icon-diamond') || '';

      const positionChangeButtons = function () {
        if (!stepOneText || !stepTwoText || !stepperChangeBtn || !stepperChangeDiamondBtn) return;
        if (isDiamondFirst()) {
          stepOneText.appendChild(stepperChangeDiamondBtn);
          stepTwoText.appendChild(stepperChangeBtn);
        } else {
          stepOneText.appendChild(stepperChangeBtn);
          stepTwoText.appendChild(stepperChangeDiamondBtn);
        }
      };

      const applyFlowPresentation = function () {
        positionChangeButtons();

        const stepOneMob = stepper.querySelector('[data-step-target="1"] .mob_visible');
        const stepTwoMob = stepper.querySelector('[data-step-target="2"] .mob_visible');

        if (stepOneIcon && stepTwoIcon && iconSettingUrl && iconDiamondUrl) {
          if (isDiamondFirst()) {
            stepOneIcon.src = iconDiamondUrl;
            stepTwoIcon.src = iconSettingUrl;
          } else {
            stepOneIcon.src = iconSettingUrl;
            stepTwoIcon.src = iconDiamondUrl;
          }
        }

        if (isDiamondFirst()) {
          if (stepOneMob) stepOneMob.textContent = 'Diamond';
          if (stepTwoMob) stepTwoMob.textContent = 'Setting';
          stepper.classList.add('is-diamond-first');
          stepper.classList.remove('is-setting-first');
        } else {
          if (stepOneMob) stepOneMob.textContent = 'Setting';
          if (stepTwoMob) stepTwoMob.textContent = 'Diamond';
          stepper.classList.add('is-setting-first');
          stepper.classList.remove('is-diamond-first');
        }
      };

      window.RingBuilderFlow = {
        getFlow: getFlow,
        setFlow: setFlow,
        setPresentation: setPresentation,
        isDiamondFirst: isDiamondFirst,
        getLogicalStepForContent: getLogicalStepForContent,
        getContentForLogicalStep: getContentForLogicalStep,
        getFlowFromPath: getFlowFromPath,
        buildRingBuilderUrl: buildRingBuilderUrl,
        getFlowPathSegment: getFlowPathSegment,
        RING_BUILDER_BASE: RING_BUILDER_BASE,
        FLOW_SETTING_FIRST: FLOW_SETTING_FIRST,
        FLOW_DIAMOND_FIRST: FLOW_DIAMOND_FIRST
      };

      const formatMoney = function (cents) {
        if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
          return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
        }
        return '$' + (Number(cents || 0) / 100).toFixed(2);
      };

      const escapeHtml = function (value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };

      const normalizeList = function (value) {
        return String(value || '')
          .split(',')
          .map(function (item) { return item.trim(); })
          .filter(Boolean);
      };

      // Strip leading AU and replace Chinese 陆 with ½ (same as PDP ring size options).
      const formatRingSizeLabel = function (raw) {
        var label = String(raw == null ? '' : raw).replace(/陆/g, '½').trim();
        label = label.replace(/^au\s+/i, '').replace(/^au(?=[^a-z]|$)/i, '').trim();
        return label;
      };

      const normalizeRingSizeList = function (value) {
        var seen = {};
        return normalizeList(value)
          .map(formatRingSizeLabel)
          .filter(function (label) {
            if (!label || seen[label]) return false;
            seen[label] = true;
            return true;
          });
      };

      const hideSettingPreview = function () {
        if (featuredPanel) featuredPanel.hidden = true;
        if (featuredDetailPanel) featuredDetailPanel.hidden = true;
        if (browseContent) browseContent.hidden = false;
        if (settingPreviewBody) settingPreviewBody.innerHTML = '';
        activeSettingProduct = null;
        activeSettingCard = null;
      };

      const findSelectedSettingVariant = function () {
        if (!activeSettingProduct || !settingPreviewBody) return null;
        const selectedOptions = Array.from(settingPreviewBody.querySelectorAll('[data-setting-option-select]')).map(function (select) {
          return select.value;
        });
        return activeSettingProduct.variants.find(function (variant) {
          return selectedOptions.every(function (value, index) {
            return String(variant.options[index]) === String(value);
          });
        }) || activeSettingProduct.variants[0] || null;
      };

      const updateSettingPreviewVariant = function () {
        if (!settingPreviewBody) return;
        const variant = findSelectedSettingVariant();
        if (!variant) return;

        const priceEl = settingPreviewBody.querySelector('[data-setting-preview-price]');
        const imageEl = settingPreviewBody.querySelector('[data-setting-preview-image]');
        const chooseBtn = settingPreviewBody.querySelector('[data-setting-preview-choose]');
        const noticeEl = settingPreviewBody.querySelector('[data-setting-preview-notice]');

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (imageEl) {
          const imageSrc = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : activeSettingProduct.featured_image;
          if (imageSrc) imageEl.src = imageSrc;
        }
        if (chooseBtn) {
          chooseBtn.disabled = !variant.available;
          chooseBtn.textContent = variant.available ? 'Choose this setting' : 'Sold out';
        }
        if (noticeEl) {
          noticeEl.hidden = !!variant.available;
          noticeEl.textContent = variant.available ? '' : 'This variant is sold out. Please choose another option.';
        }
      };

      const renderSettingPreview = function (product, productCard) {
        if (!settingPreviewBody) return;
        activeSettingProduct = product;
        activeSettingCard = productCard;

        const trigger = productCard.querySelector('.js-btn-quickview');
        const ringSizes = normalizeRingSizeList(
          productCard.getAttribute('data-ring-builder-ring-size') ||
          (trigger ? trigger.getAttribute('data-ring-size') : '')
        );
        const bandWidths = normalizeList(
          productCard.getAttribute('data-ring-builder-band-width') ||
          (trigger ? trigger.getAttribute('data-band-width') : '')
        );
        const prongTypes = normalizeList(
          productCard.getAttribute('data-ring-builder-prong-type') ||
          (trigger ? trigger.getAttribute('data-prong-type') : '')
        );
        const firstVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
        const imageSrc = (firstVariant && firstVariant.featured_image && firstVariant.featured_image.src) || product.featured_image || '';

        const isHiddenSettingCaratOption = function (optionName) {
          const n = String(optionName || '').replace(/\s+/g, ' ').trim().toLowerCase();
          return n.indexOf('carat') !== -1;
        };

        const optionHtml = product.options.map(function (option, index) {
          const values = [];
          product.variants.forEach(function (variant) {
            const value = variant.options[index];
            if (values.indexOf(value) === -1) values.push(value);
          });
          const optionName = option.name || option;
          // Keep select in DOM for variant matching, but hide carat options (diamond supplies real carat).
          const hiddenAttr = isHiddenSettingCaratOption(optionName)
            ? ' hidden aria-hidden="true" class="ring-builder-setting-preview__field ring-builder-setting-preview__field--hidden-carat"'
            : ' class="ring-builder-setting-preview__field"';
          return '<div' + hiddenAttr + '>' +
            '<label for="RingBuilderSettingOption-' + index + '">' + escapeHtml(optionName) + '</label>' +
            '<select id="RingBuilderSettingOption-' + index + '" data-setting-option-select>' +
            values.map(function (value) {
              const selected = firstVariant && firstVariant.options[index] === value ? ' selected' : '';
              return '<option value="' + escapeHtml(value) + '"' + selected + '>' + escapeHtml(value) + '</option>';
            }).join('') +
            '</select>' +
            '</div>';
        }).join('');

        const listSelectHtml = function (id, label, values, options) {
          if (!values.length) return '';
          options = options || {};
          const required = !!options.required;
          const placeholder = options.placeholder || ('Select ' + String(label).toLowerCase());
          return '<div class="ring-builder-setting-preview__field">' +
            '<label for="' + id + '">' + label + '</label>' +
            '<select id="' + id + '" data-setting-extra="' + id + '"' + (required ? ' required' : '') + '>' +
            (required
              ? '<option value="" selected disabled>' + escapeHtml(placeholder) + '</option>'
              : '') +
            values.map(function (value) {
              return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>';
            }).join('') +
            '</select>' +
            '</div>';
        };

        settingPreviewBody.innerHTML =
          '<div class="ring-builder-setting-preview__grid">' +
            '<div class="ring-builder-setting-preview__media">' +
              (imageSrc ? '<img data-setting-preview-image src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(product.title) + '">' : '<span>No image</span>') +
            '</div>' +
            '<div class="ring-builder-setting-preview__content">' +
              '<h2 class="ring-builder-setting-preview__title">' + escapeHtml(product.title) + '</h2>' +
              '<div class="ring-builder-setting-preview__price" data-setting-preview-price>' + (firstVariant ? formatMoney(firstVariant.price) : '') + '</div>' +
              optionHtml +
              listSelectHtml('RingBuilderRingSize', 'Ring size', ringSizes, { required: true, placeholder: 'Select ring size' }) +
              listSelectHtml('RingBuilderBandWidth', 'Band width', bandWidths, { required: true, placeholder: 'Select band width' }) +
              listSelectHtml('RingBuilderProngType', 'Prong type', prongTypes) +
              '<div class="ring-builder-setting-preview__field">' +
                '<label for="RingBuilderEngraving">Engraving / notes</label>' +
                '<input id="RingBuilderEngraving" type="text" data-setting-extra="engraving" maxlength="60" placeholder="Optional">' +
              '</div>' +
              '<div class="ring-builder-setting-preview__actions">' +
                '<button type="button" class="ring-builder-setting-preview__choose" data-setting-preview-choose>Choose this setting</button>' +
              '</div>' +
              '<p class="ring-builder-setting-preview__notice" data-setting-preview-notice hidden></p>' +
            '</div>' +
          '</div>';

        settingPreviewBody.querySelectorAll('[data-setting-option-select]').forEach(function (select) {
          select.addEventListener('change', updateSettingPreviewVariant);
        });

        const chooseBtn = settingPreviewBody.querySelector('[data-setting-preview-choose]');
        if (chooseBtn) {
          chooseBtn.addEventListener('click', function () {
            const variant = findSelectedSettingVariant();
            if (!variant || !variant.available) return;

            const ringSizeEl = settingPreviewBody.querySelector('[data-setting-extra="RingBuilderRingSize"]');
            const bandWidthEl = settingPreviewBody.querySelector('[data-setting-extra="RingBuilderBandWidth"]');
            const prongTypeEl = settingPreviewBody.querySelector('[data-setting-extra="RingBuilderProngType"]');
            const engravingEl = settingPreviewBody.querySelector('[data-setting-extra="engraving"]');

            const requiredExtras = [ringSizeEl, bandWidthEl].filter(Boolean);
            for (let i = 0; i < requiredExtras.length; i++) {
              const field = requiredExtras[i];
              if (field.value && String(field.value).trim()) continue;
              const label = (field.id && settingPreviewBody.querySelector('label[for="' + field.id + '"]'));
              const labelText = label ? label.textContent.trim().toLowerCase() : 'option';
              if (typeof window.focusRequiredProductField === 'function') {
                window.focusRequiredProductField(field, {
                  message: 'Please select a ' + labelText + '.',
                });
              } else {
                try {
                  field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch (err) {
                  field.scrollIntoView(true);
                }
                field.focus();
              }
              return;
            }

            const imageUrl = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
            const selectedOptions = Array.from(settingPreviewBody.querySelectorAll('[data-setting-option-select]')).map(function (select, index) {
              return { index: index, value: select.value };
            });

            const resolveDiamondShape = function () {
              if (window.RingBuilderShapeUtils && typeof window.RingBuilderShapeUtils.extractDiamondShape === 'function') {
                const fromPreview = settingPreviewBody ? window.RingBuilderShapeUtils.extractDiamondShape(settingPreviewBody) : '';
                if (fromPreview) return fromPreview;
              }
              if (activeSettingCard) {
                const fromCard = (activeSettingCard.getAttribute('data-ring-builder-shape') || '').trim();
                if (fromCard) return fromCard;
                if (window.RingBuilderShapeUtils && typeof window.RingBuilderShapeUtils.extractDiamondShape === 'function') {
                  return window.RingBuilderShapeUtils.extractDiamondShape(activeSettingCard) || '';
                }
              }
              return '';
            };

            const diamondShape = resolveDiamondShape();

            localStorage.setItem('ringBuilderSelectedSetting', JSON.stringify({
              productHandle: product.handle,
              productTitle: product.title,
              variantId: variant.id,
              variantTitle: variant.title,
              imageUrl: imageUrl,
              price: Number(variant.price || 0) / 100,
              options: selectedOptions,
              ringSize: ringSizeEl ? ringSizeEl.value : '',
              bandWidth: bandWidthEl ? bandWidthEl.value : '',
              prongType: prongTypeEl ? prongTypeEl.value : '',
              engraving: engravingEl ? engravingEl.value : '',
              diamondShape: diamondShape,
              quantity: '1'
            }));

            const hasDiamond = localStorage.getItem('ringBuilderSelectedDiamond');
            const nextStep = hasDiamond ? '3' : getLogicalStepForContent('diamond');

            document.dispatchEvent(new CustomEvent('ring-builder:setting-selected', {
              bubbles: true,
              detail: { nextStep: nextStep }
            }));
          });
        }

        updateSettingPreviewVariant();
      };

      const getSettingPdpUrl = function (productCard) {
        const trigger = productCard.querySelector('.js-btn-quickview');
        const handle = (trigger && trigger.getAttribute('data-handle')) || productCard.getAttribute('data-ring-builder-product-handle');
        const rawUrl = productCard.getAttribute('data-ring-builder-product-url') || (handle ? '/products/' + handle : '');
        try {
          const url = new URL(rawUrl, window.location.origin);
          url.searchParams.set('ring-builder', 'true');
          url.searchParams.set('flow', getFlow());
          if (window.location.search.indexOf('_fd=0') !== -1) {
            url.searchParams.set('_fd', '0');
          }
          return url.pathname + url.search;
        } catch (e) {
          const joiner = rawUrl.indexOf('?') === -1 ? '?' : '&';
          return rawUrl + joiner + 'ring-builder=true&flow=' + encodeURIComponent(getFlow());
        }
      };

      const wireRingBuilderProductCards = function () {
        root.querySelectorAll('[data-ring-builder-product-card]').forEach(function (productCard) {
          if (productCard.getAttribute('data-ring-builder-pdp-wired') === 'true') return;
          productCard.setAttribute('data-ring-builder-pdp-wired', 'true');

          const pdpUrl = getSettingPdpUrl(productCard);

          productCard.querySelectorAll('a[href]').forEach(function (link) {
            try {
              const url = new URL(link.href, window.location.origin);
              if (url.pathname.indexOf('/products/') === -1) return;
              link.href = pdpUrl;
            } catch (e) {}
          });

          productCard.querySelectorAll('.js-btn-quickview').forEach(function (btn) {
            btn.removeAttribute('data-toggle');
            btn.removeAttribute('data-target');
            btn.setAttribute('data-ring-builder-pdp', 'true');
            btn.setAttribute('role', 'link');
            btn.setAttribute('tabindex', '0');
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              window.location.href = pdpUrl;
            }, true);
            btn.addEventListener('keydown', function (e) {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              e.preventDefault();
              window.location.href = pdpUrl;
            });
          });
        });
      };

      if (browseContent) {
        const paginationObserver = new MutationObserver(function () {
          wireRingBuilderProductCards();
        });
        paginationObserver.observe(browseContent, { childList: true, subtree: true });
      }

      if (settingBackBtn) {
        settingBackBtn.addEventListener('click', function (event) {
          event.preventDefault();
          hideSettingPreview();
        });
      }

      const setStepLabelState = function (stepNum, contentType, isSelected, displayName) {
        const labelEl = stepNum === '1' ? stepOneLabel : stepTwoLabel;
        const changeBtn = contentType === 'setting' ? stepperChangeBtn : stepperChangeDiamondBtn;
        const defaultLabel = contentType === 'setting' ? 'Choose a Setting' : 'Choose a Diamond';
        const selectedPrefix = contentType === 'setting' ? 'Setting' : 'Diamond';
        const shortLabel = contentType === 'setting' ? 'Setting' : 'Diamond';
        const stepButton = stepper.querySelector('[data-step-target="' + stepNum + '"]');
        const mobVisibleEl = stepButton ? stepButton.querySelector('.mob_visible') : null;

        if (changeBtn) {
          changeBtn.hidden = false;
          changeBtn.textContent = isSelected ? 'Change' : 'Search';
        }
        if (labelEl) {
          if (isSelected) {
            labelEl.textContent = displayName ? (selectedPrefix + ': ' + displayName) : (selectedPrefix + ' Selected');
          } else {
            labelEl.textContent = defaultLabel;
          }
        }
        if (mobVisibleEl) {
          mobVisibleEl.textContent = shortLabel;
        }
      };

      const showBrowseUI = function () {
        if (browseContent) {
          browseContent.hidden = false;
        }
      };

      const syncStepperVisuals = function () {
        const selectedSettingRaw = localStorage.getItem('ringBuilderSelectedSetting');
        const selectedDiamondRaw = localStorage.getItem('ringBuilderSelectedDiamond');

        let settingName = '';
        let diamondName = '';
        let hasSetting = false;
        let hasDiamond = false;

        if (selectedSettingRaw) {
          try {
            const selectedSetting = JSON.parse(selectedSettingRaw);
            hasSetting = true;
            settingName = selectedSetting.productTitle || '';
          } catch (e) {}
        }

        if (selectedDiamondRaw) {
          try {
            const selectedDiamond = JSON.parse(selectedDiamondRaw);
            hasDiamond = true;
            const carat = selectedDiamond.carats ? Number(selectedDiamond.carats).toFixed(2) + 'ct ' : '';
            const shape = selectedDiamond.shape ? selectedDiamond.shape.charAt(0).toUpperCase() + selectedDiamond.shape.slice(1).toLowerCase() : 'Diamond';
            diamondName = carat + shape;
          } catch (e) {}
        }

        const step1Content = logicalToContentType('1');
        const step2Content = logicalToContentType('2');

        setStepLabelState('1', step1Content, step1Content === 'setting' ? hasSetting : hasDiamond, step1Content === 'setting' ? settingName : diamondName);
        setStepLabelState('2', step2Content, step2Content === 'setting' ? hasSetting : hasDiamond, step2Content === 'setting' ? settingName : diamondName);

        buttons.forEach(function (button) {
          const logicalStep = button.getAttribute('data-step-target');
          let isDone = false;

          if (logicalStep === '1') {
            isDone = step1Content === 'setting' ? hasSetting : hasDiamond;
          } else if (logicalStep === '2') {
            isDone = step2Content === 'setting' ? hasSetting : hasDiamond;
          } else if (logicalStep === '3') {
            isDone = hasSetting && hasDiamond;
          }

          const isActive = button.classList.contains('is-active');
          button.classList.toggle('is-done', Boolean(isDone) && !isActive);
        });
      };

      const showStep = function (stepTarget, activeContentType) {
        buttons.forEach(function (button) {
          const isActive = button.getAttribute('data-step-target') === stepTarget;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');

          const logicalStep = button.getAttribute('data-step-target');
          const contentType = logicalToContentType(logicalStep);
          const panel = panels.find(function (item) {
            return item.getAttribute('data-step-content') === contentType;
          });
          if (panel) {
            button.setAttribute('aria-controls', panel.id);
          }
        });

        panels.forEach(function (panel) {
          const isActive = panel.getAttribute('data-step-content') === activeContentType;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        if (stepperNav) {
          stepperNav.setAttribute('data-active-step', String(stepTarget));
        }

        if (heroWrap) {
          heroWrap.classList.toggle('is-step-setting', activeContentType === 'setting');
          heroWrap.classList.toggle('is-step-diamond', activeContentType === 'diamond');
          heroWrap.classList.toggle('is-step-complete', activeContentType === 'complete');
        }

        currentStep = stepTarget;
        localStorage.setItem('ringBuilderCurrentStep', stepTarget);

        const nextUrl = buildRingBuilderUrl(getFlow(), stepTarget);
        const histState = { step: stepTarget, flow: getFlow() };
        // First paint / same-step sync: replace. Real step changes: push.
        if (
          !history.state ||
          history.state.step == null ||
          (String(history.state.step) === String(stepTarget) &&
            history.state.flow === getFlow())
        ) {
          history.replaceState(histState, '', nextUrl);
        } else {
          history.pushState(histState, '', nextUrl);
        }

        if (activeContentType === 'setting') {
          showBrowseUI();
          hideSettingPreview();
          wireRingBuilderProductCards();
        }

        if (activeContentType === 'diamond' && window.RingBuilderDiamonds) {
          if (typeof window.RingBuilderDiamonds.initStep2 === 'function') {
            window.RingBuilderDiamonds.initStep2();
          }
        }

        if (activeContentType === 'complete') {
          renderCompleteSummary();
        }

        syncStepperVisuals();
      };

      // While nothing is selected, first path opened becomes Step 1 (flexible start).
      const lockFlowFromIntentIfEmpty = function (contentType) {
        if (contentType !== 'setting' && contentType !== 'diamond') return;
        const hasSetting = !!localStorage.getItem('ringBuilderSelectedSetting');
        const hasDiamond = !!localStorage.getItem('ringBuilderSelectedDiamond');
        if (hasSetting || hasDiamond) return;
        setPresentation(
          contentType === 'diamond' ? FLOW_DIAMOND_FIRST : FLOW_SETTING_FIRST
        );
      };

      const navigateToContent = function (contentType) {
        lockFlowFromIntentIfEmpty(contentType);
        const stepTarget = validateLogicalStep(
          contentType === 'complete' ? '3' : getLogicalStepForContent(contentType)
        );

        showStep(stepTarget, contentType === 'complete' ? 'complete' : contentType);
      };

      const openStepContent = function (contentType) {
        navigateToContent(contentType);
      };

      const activateStep = function (stepTarget) {
        const validated = validateLogicalStep(String(stepTarget || '1'));
        const contentType = getContentForLogicalStep(validated);
        navigateToContent(contentType === 'complete' ? 'complete' : contentType);
      };

      const inferFlowFromSelections = function () {
        const hasSetting = !!localStorage.getItem('ringBuilderSelectedSetting');
        const hasDiamond = !!localStorage.getItem('ringBuilderSelectedDiamond');
        if (hasDiamond && !hasSetting) return FLOW_DIAMOND_FIRST;
        if (hasSetting && !hasDiamond) return FLOW_SETTING_FIRST;
        const stored = localStorage.getItem(FLOW_KEY);
        if (stored === FLOW_DIAMOND_FIRST || stored === FLOW_SETTING_FIRST) return stored;
        return FLOW_SETTING_FIRST;
      };

      const bindCompleteGallerySticky = function (container) {
        if (!container) return;

        if (container._rbGalleryStickyCleanup) {
          container._rbGalleryStickyCleanup();
          container._rbGalleryStickyCleanup = null;
        }

        const col = container.querySelector('[data-rb-complete-gallery-col]');
        const gallery = container.querySelector('[data-rb-complete-gallery]');
        if (!col || !gallery) return;

        const mq = window.matchMedia('(min-width: 992px)');
        let rafId = null;

        const parseCssPx = function (value) {
          const num = parseFloat(value);
          return isFinite(num) ? num : 0;
        };

        const getTopOffset = function () {
          const rootStyles = getComputedStyle(document.documentElement);
          let header = parseCssPx(rootStyles.getPropertyValue('--height-header'));
          if (!header) header = parseCssPx(rootStyles.getPropertyValue('--header-height'));
          let announcementBar = parseCssPx(rootStyles.getPropertyValue('--height-announcementbar'));
          let announBar = parseCssPx(rootStyles.getPropertyValue('--height-announbar'));

          if (!header) {
            const headerEl = document.querySelector('.section-header, .header-wrapper, sticky-header');
            if (headerEl) header = headerEl.offsetHeight;
          }
          if (!announcementBar && !announBar) {
            const announcementEl = document.querySelector(
              '.announcement-split, #announcement-topbar, .announcement-bar, .header-announcement, .announcement-bar-carousel'
            );
            if (announcementEl) {
              const announcementSection = announcementEl.closest('.shopify-section') || announcementEl;
              announcementBar = announcementSection.offsetHeight;
            }
          }

          const gap = parseCssPx(rootStyles.fontSize) || 16;
          return Math.round(header + announcementBar + announBar + gap);
        };

        const clearStyles = function () {
          gallery.style.position = '';
          gallery.style.top = '';
          gallery.style.left = '';
          gallery.style.width = '';
        };

        const update = function () {
          if (!mq.matches) {
            clearStyles();
            return;
          }

          // The gallery column only contains the gallery itself, so its height
          // collapses once the gallery is taken out of flow. Measure the row
          // (as tall as the info column beside it) to drive the sticky range.
          const rowEl = col.parentElement;
          if (!rowEl) {
            clearStyles();
            return;
          }

          const topOffset = getTopOffset();
          const colRect = col.getBoundingClientRect();
          const rowRect = rowEl.getBoundingClientRect();
          const galleryH = gallery.offsetHeight;
          const rowH = rowEl.offsetHeight;

          if (rowH <= galleryH + 8) {
            clearStyles();
            return;
          }

          if (rowRect.top >= topOffset) {
            clearStyles();
            return;
          }

          if (rowRect.bottom <= topOffset + galleryH) {
            gallery.style.position = 'absolute';
            gallery.style.top = Math.max(0, rowH - galleryH) + 'px';
            gallery.style.left = '0';
            gallery.style.width = '100%';
            return;
          }

          gallery.style.position = 'fixed';
          gallery.style.top = topOffset + 'px';
          gallery.style.left = colRect.left + 'px';
          gallery.style.width = colRect.width + 'px';
        };

        const schedule = function () {
          if (rafId) return;
          rafId = window.requestAnimationFrame(function () {
            rafId = null;
            update();
          });
        };

        const onScroll = schedule;
        const onResize = schedule;
        const onMqChange = schedule;

        mq.addEventListener('change', onMqChange);
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);
        gallery.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', schedule, { once: true });
        });

        schedule();

        container._rbGalleryStickyCleanup = function () {
          if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
          }
          mq.removeEventListener('change', onMqChange);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onResize);
          clearStyles();
        };
      };

      const renderCompleteSummary = function () {
        const container = root.querySelector('[data-ring-builder-complete]');
        if (!container) return;

        const selectedSettingRaw = localStorage.getItem('ringBuilderSelectedSetting');
        const selectedDiamondRaw = localStorage.getItem('ringBuilderSelectedDiamond');

        if (!selectedSettingRaw || !selectedDiamondRaw) {
          container.innerHTML = `
            <div class="ring-builder-stepper__placeholder">
              <h3>Step 3: Complete Ring</h3>
              <p>Please select both a setting and a diamond to view the summary.</p>
            </div>
          `;
          return;
        }

        const setting = JSON.parse(selectedSettingRaw);
        const diamond = JSON.parse(selectedDiamondRaw);

        const settingPrice = Number(setting.price) || 0;
        const diamondPriceRaw = window.RingBuilderDiamondMargin
          ? window.RingBuilderDiamondMargin.applyMarginToNivodaCents(diamond.price)
          : (Number(diamond.price) || 0) / 100;
        const diamondPrice = Math.round(diamondPriceRaw);
        const totalPrice = settingPrice + diamondPrice;

        const formatMoney = function (amount) {
          if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
            return window.theme.Currency.formatMoney(Math.round(amount * 100), window.theme.moneyFormat);
          }
          return '$' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        };

        const formatMoneyRounded = function (amount) {
          if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
            return window.theme.Currency.formatMoney(Math.round(amount) * 100, window.theme.moneyFormat);
          }
          return '$' + Math.round(amount).toLocaleString();
        };

        const getCompleteConfig = function () {
          const configEl = document.getElementById('RingBuilderCompleteConfig');
          if (!configEl) return {};
          try {
            return JSON.parse(configEl.textContent);
          } catch (e) {
            return {};
          }
        };

        const formatDeliveryRange = function (minDays, maxDays) {
          const min = Number(minDays) || 30;
          const max = Number(maxDays) || 35;
          const now = new Date();
          const start = new Date(now);
          const end = new Date(now);
          start.setDate(start.getDate() + min);
          end.setDate(end.getDate() + max);
          const fmt = function (date) {
            return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
          };
          return fmt(start) + ' \u2013 ' + fmt(end);
        };

        const engravingMaxChars = (window.theme && window.theme.engravingNotesMaxChars) || 5;

        const escapeHtml = function (value) {
          return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
        };

        const diamondShape = diamond.shape
          ? diamond.shape.charAt(0).toUpperCase() + diamond.shape.slice(1).toLowerCase()
          : 'Diamond';
        const settingPdpUrl = setting.productHandle
          ? '/products/' +
            setting.productHandle +
            '?ring-builder=true&flow=' +
            encodeURIComponent(getFlow()) +
            (setting.variantId ? '&variant=' + encodeURIComponent(setting.variantId) : '')
          : '#';

        const buildCertUrl = function (d) {
          const cert = String(d.certNumber || d.offerId || '').trim();
          if (!cert) return '';
          const lab = String(d.lab || '').toUpperCase();
          if (lab === 'GIA') return 'https://www.gia.edu/report-check?reportno=' + encodeURIComponent(cert);
          if (lab === 'IGI') return 'https://www.igi.org/verify.php?r=' + encodeURIComponent(cert);
          return '';
        };

        const certUrl = buildCertUrl(diamond);
        const certLabel = (diamond.lab || 'IGI') + (diamond.certNumber ? ' #' + diamond.certNumber : '');
        const engravingValue = setting.engraving || '';
        const completeConfig = getCompleteConfig();
        const deliveryRange = formatDeliveryRange(completeConfig.deliveryMinDays, completeConfig.deliveryMaxDays);
        const deliveryText = completeConfig.deliveryText || 'Order today to get by';
        const specsTitle = completeConfig.specsTitle || 'Product Specifications';
        const shippingTitle = completeConfig.shippingTitle || 'Free Shipping & Return';
        const shippingContent = completeConfig.shippingContent || '';
        const diamondDetailsUrl = certUrl || '#';

        const ringIconSvg = '<img src="//diamondsforeveryone.com.au/cdn/shop/files/start-with-setting.png?v=1784546988&amp;width=40" alt="" width="20" height="20" loading="lazy" decoding="async">';
        const diamondIconSvg = '<img src="//diamondsforeveryone.com.au/cdn/shop/files/start-with-lab-grown-diamond.png?v=1784546985&amp;width=40" alt="" width="20" height="20" loading="lazy" decoding="async">';
        const truckIconSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

        const selectionRow = function (iconSvg, typeLabel, title, meta, price, changeTarget, detailsUrl, detailsExternal) {
          const detailsAttrs = detailsExternal
            ? ' target="_blank" rel="noopener noreferrer"'
            : (detailsUrl === '#' ? '' : '');
          return '<div class="rb-complete-selection-row">' +
            '<div class="rb-complete-selection-row__icon">' + iconSvg + '</div>' +
            '<div class="rb-complete-selection-row__content">' +
            '<span class="rb-complete-selection-row__type">' + escapeHtml(typeLabel) + '</span>' +
            '<strong class="rb-complete-selection-row__title">' + escapeHtml(title) + '</strong>' +
            (meta ? '<span class="rb-complete-selection-row__meta">' + escapeHtml(meta) + '</span>' : '') +
            '<div class="rb-complete-selection-row__actions">' +
            '<a href="#" data-ring-builder-complete-change="' + escapeHtml(changeTarget) + '">Change</a>' +
            '<span class="rb-complete-selection-row__sep">|</span>' +
            '<a href="' + escapeHtml(detailsUrl) + '"' + detailsAttrs + '>View Details</a>' +
            '</div>' +
            '</div>' +
            '<strong class="rb-complete-selection-row__price">' + escapeHtml(price) + '</strong>' +
            '</div>';
        };

        const formatShapeLabel = function (shape) {
          if (!shape) return '-';
          return String(shape)
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
        };

        const formatDiamondTitleDisplay = function (d) {
          const carats = Number(d.carats);
          let caratLabel = '';
          if (isFinite(carats)) {
            caratLabel = (carats % 1 === 0 ? String(carats) : carats.toFixed(2).replace(/\.?0+$/, '')) + ' Carat ';
          }
          const shape = formatShapeLabel(d.shape);
          const suffix = d.labgrown ? ' Lab Grown Diamond' : ' Natural Diamond';
          return caratLabel + shape + suffix;
        };
        const diamondTitle = formatDiamondTitleDisplay(diamond);
        const combinedTitle = setting.productTitle + ' with ' + diamondTitle;

        const formatCutLabel = function (cut) {
          if (!cut) return 'N/A';
          const normalized = String(cut).trim().toUpperCase();
          const labels = {
            EX: 'EX',
            EXCELLENT: 'EX',
            VG: 'VG',
            VERY_GOOD: 'VG',
            G: 'G',
            GOOD: 'G',
            ID: 'IDL',
            IDEAL: 'IDL',
            IDL: 'IDL'
          };
          return labels[normalized] || normalized;
        };

        const formatCaratsDisplay = function (carats) {
          if (!carats) return 'N/A';
          const num = Number(carats);
          if (!isFinite(num)) return 'N/A';
          return num.toFixed(1) + 'ct';
        };

        const formatDimensionsDisplay = function (d) {
          const length = Number(d.length);
          const width = Number(d.width);
          const depth = Number(d.depth);
          if (isFinite(length) && isFinite(width) && isFinite(depth)) {
            return length.toFixed(2) + ' x ' + width.toFixed(2) + ' x ' + depth.toFixed(2);
          }
          if (isFinite(length) && isFinite(width)) {
            return length.toFixed(2) + ' Ã— ' + width.toFixed(2) + 'mm';
          }
          return 'N/A';
        };

        const getMetalLabel = function (s) {
          if (s.variantTitle && s.variantTitle !== 'Default Title') {
            return s.variantTitle;
          }
          if (s.options && s.options.length) {
            return s.options.map(function (opt) { return opt.value; }).filter(Boolean).join(' / ');
          }
          return '-';
        };

        const formatBandWidthDisplay = function (bw) {
          if (!bw) return '-';
          const value = String(bw).trim();
          return /mm/i.test(value) ? value : value + 'mm';
        };

        const formatProngDisplay = function (prong) {
          if (!prong) return '-';
          return String(prong).charAt(0).toUpperCase() + String(prong).slice(1).toLowerCase();
        };

        const buildSpecTableRows = function (specs) {
          return specs.map(function (spec) {
            return '<tr><td>' + escapeHtml(spec.label) + '</td><td>' + escapeHtml(spec.value || '—') + '</td></tr>';
          }).join('');
        };

        const formatCaratMetaLabel = function (carats) {
          if (!carats) return '';
          const num = Number(carats);
          if (!isFinite(num)) return '';
          const label = num % 1 === 0 ? String(num) : num.toFixed(2).replace(/\.?0+$/, '');
          return label + ' CT';
        };

        const buildRingDetailsMetaHtml = function () {
          const metaParts = [];
          const metalCarat = [getMetalLabel(setting), formatCaratMetaLabel(diamond.carats)].filter(Boolean).join(' / ');
          if (metalCarat) metaParts.push(escapeHtml(metalCarat));
          if (setting.ringSize) metaParts.push('Ring size ' + escapeHtml(formatRingSizeLabel(setting.ringSize)));
          if (setting.productHandle) {
            metaParts.push('<a href="' + escapeHtml(settingPdpUrl) + '">View setting</a>');
          }
          if (certUrl) {
            metaParts.push('<a href="' + escapeHtml(certUrl) + '" target="_blank" rel="noopener">View certificate</a>');
          }
          return metaParts.join(' &middot; ');
        };

        const infoIconSvg = '<svg class="rb-complete-info-icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="8" cy="8" r="6.75" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="8" cy="5.25" r="0.75" fill="currentColor"/><path d="M8 7.25v3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

        const infoBtn = function (label, title) {
          if (!title) return '';
          return '<button type="button" class="rb-complete-info-btn" aria-label="' + escapeHtml(label) + ' information" title="' + escapeHtml(title) + '">' + infoIconSvg + '</button>';
        };

        const settingSpecCell = function (label, value, changeTarget, infoTitle, hintSubtext) {
          const hasPdp = settingPdpUrl && settingPdpUrl !== '#';
          const changeLink = hasPdp
            ? '<a href="' + escapeHtml(settingPdpUrl) + '" class="rb-complete-setting-cell__change">CHANGE</a>'
            : '<a href="#" class="rb-complete-setting-cell__change" data-ring-builder-complete-change="' +
              escapeHtml(changeTarget) +
              '">CHANGE</a>';
          return '<div class="rb-complete-setting-cell">' +
            '<div class="rb-complete-setting-cell__head">' +
            '<span class="rb-complete-setting-cell__label">' + escapeHtml(label) + '</span>' +
            changeLink +
            '</div>' +
            '<strong class="rb-complete-setting-cell__value">' + escapeHtml(value || '-') + '</strong>' +
            (hintSubtext ? '<span class="rb-complete-setting-cell__hint">' + escapeHtml(hintSubtext) + '</span>' : '') +
            '</div>';
        };

        const diamondSpecCell = function (label, value, hint) {
          return '<div class="rb-complete-diamond-cell">' +
            '<div class="rb-complete-diamond-cell__head">' +
            '<span class="rb-complete-diamond-cell__label">' + escapeHtml(label) + '</span>' +
            '</div>' +
            '<strong class="rb-complete-diamond-cell__value">' + escapeHtml(value || 'N/A') + '</strong>' +
            '</div>';
        };

        const diamondSpecsLeft = [
          { label: 'Shape', value: formatShapeLabel(diamond.shape) },
          { label: 'Carat Weight', value: formatCaratsDisplay(diamond.carats) },
          { label: 'Color', value: diamond.color || '-' },
          { label: 'Clarity', value: diamond.clarity || '-' },
          { label: 'Cut Grade', value: formatCutLabel(diamond.cut) },
          { label: 'Lab', value: diamond.lab || '-' }
        ];

        const diamondSpecsRight = [
          { label: 'Certificate Number', value: diamond.certNumber || '-' },
          { label: 'Dimensions', value: formatDimensionsDisplay(diamond) },
          { label: 'Polish', value: diamond.polish || '-' },
          { label: 'Symmetry', value: diamond.symmetry || '-' },
          { label: 'Fluorescence', value: diamond.fluorescence || '-' },
          { label: 'Origin', value: diamond.labgrown ? 'Lab Grown' : 'Natural' }
        ];

        const productInfoAccordion = function (heading, bodyHtml, bodyAttr, openByDefault) {
          const attr = bodyAttr ? ' ' + bodyAttr : '';
          const openAttr = openByDefault ? ' open' : '';
          return '<div class="product-info-row product__accordion accordion quick-add-hidden">' +
            '<details' + openAttr + '>' +
            '<summary>' +
            '<div class="summary__title">' +
            '<h2 class="h4 accordion__title inline-richtext">' + escapeHtml(heading) + '</h2>' +
            '</div>' +
            '<span class="product-info-row__toggle" aria-hidden="true">' +
            '<span class="product-info-row__plus">+</span>' +
            '<span class="product-info-row__minus">-</span>' +
            '</span>' +
            '</summary>' +
            '<div class="accordion__content rte"' + attr + '>' + (bodyHtml || '') + '</div>' +
            '</details>' +
            '</div>';
        };
        const ringDetailsPanel =
          '<div class="diamond-detail-specs-panel">' +
          '<p class="diamond-detail-specs-panel__intro">' +
          '<strong>' + escapeHtml(setting.productTitle) + '</strong><br>' +
          buildRingDetailsMetaHtml() +
          '</p>' +
          '<div class="rb-complete-specs-grid">' +
          '<div class="diamond-detail-specs-panel__col"><table class="diamond-detail-specs-table"><tbody>' +
          buildSpecTableRows(diamondSpecsLeft) +
          '</tbody></table></div>' +
          '<div class="diamond-detail-specs-panel__col"><table class="diamond-detail-specs-table"><tbody>' +
          buildSpecTableRows(diamondSpecsRight) +
          '</tbody></table></div>' +
          '</div></div>';

        const galleryCell = function (src, alt, modifier) {
          const modClass = modifier ? ' rb-complete-gallery__cell--' + modifier : '';
          if (!src) {
            return '<div class="rb-complete-gallery__cell' + modClass + '"><div class="rb-complete-gallery__placeholder">No image</div></div>';
          }
          return '<div class="rb-complete-gallery__cell' + modClass + '"><img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt || '') + '" loading="lazy"></div>';
        };

        const resizeNivodaEmbedUrl = function (url, width, height) {
          if (!url) return url;
          const w = Math.max(200, Math.round(width || 500));
          const h = Math.max(200, Math.round(height || w));
          return String(url).replace(/\/(video|image)\/(\d+)\/(\d+)(?=[/?#]|$)/i, function (_match, type) {
            return '/' + type + '/' + w + '/' + h;
          });
        };

        const getCompleteShapeIconUrl = function (shape) {
          const el = document.getElementById('ring-builder-shape-icons');
          if (!el || !shape) return '';
          try {
            const urls = JSON.parse(el.textContent);
            const key = String(shape).toUpperCase().replace(/[\s-]+/g, '_');
            const aliases = {
              SQ_EMERALD: 'EMERALD',
              SQ_RADIANT: 'RADIANT',
              CUSHION_ALL: 'CUSHION',
              CUSHION_BRILLIANT: 'CUSHION',
              CUSHION_MODIFIED: 'CUSHION',
              SQUARE_CUSHION: 'CUSHION',
              HALF_MOON: 'MARQUISE',
              OLD_MINER: 'ROUND',
              EUROPEAN_CUT: 'ROUND',
              SQUARE: 'PRINCESS',
              BAGUETTE: 'EMERALD',
              TAPERED_BAGUETTE: 'EMERALD',
              BULLET: 'PEAR',
              TAPERED_BULLET: 'PEAR',
              STAR: 'ROUND',
              ROSE: 'ROUND'
            };
            if (aliases[key] && urls[aliases[key]]) return urls[aliases[key]];
            return urls[key] || '';
          } catch (e) {
            return '';
          }
        };

        const getDiamondGallerySrc = function (d) {
          const image = d && d.image && String(d.image).trim();
          if (image) {
            const imageUrl = /\/video\//i.test(image)
              ? image.replace(/\/video\//i, '/image/')
              : image;
            if (/\/(video|image)\/\d+\/\d+/i.test(imageUrl)) {
              return resizeNivodaEmbedUrl(imageUrl, 600, 600);
            }
            return imageUrl;
          }
          return getCompleteShapeIconUrl(d.shape);
        };

        const getSettingGallerySrc = function (url) {
          const src = url && String(url).trim();
          if (!src) return '';
          if (/cdn\.shopify\.com|\/cdn\/shop\//i.test(src)) {
            return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=800';
          }
          return src;
        };

        container.innerHTML = `
          <div class="rb-complete-pdp">
            <div class="row">
              <div class="col-lg-6 rb-complete-gallery-col" data-rb-complete-gallery-col>
                <div class="rb-complete-gallery" data-rb-complete-gallery>
                  ${galleryCell(getSettingGallerySrc(setting.imageUrl), setting.productTitle, 'setting')}
                  ${galleryCell(getDiamondGallerySrc(diamond), diamondTitle, 'diamond')}
                </div>
              </div>

              <div class="col-lg-6 rb-complete-info">
                <h1 class="rb-complete-info__title">${escapeHtml(combinedTitle)}</h1>

                <div class="rb-complete-selection-summary">
                  ${selectionRow(
                    ringIconSvg,
                    'Setting',
                    setting.productTitle || 'Selected Setting',
                    getMetalLabel(setting),
                    formatMoneyRounded(settingPrice),
                    'setting',
                    settingPdpUrl,
                    false
                  )}
                  ${selectionRow(
                    diamondIconSvg,
                    'Diamond',
                    diamondTitle,
                    certLabel,
                    formatMoneyRounded(diamondPrice),
                    'diamond',
                    diamondDetailsUrl,
                    !!certUrl
                  )}
                </div>

                <div class="rb-complete-engraving-block">
                  <label class="rb-complete-engraving-block__label" for="RingBuilderCompleteEngraving">
                    Add engraving text
                    ${infoBtn('Engraving', 'Optional personalised engraving on your ring')}
                  </label>
                  <input
                    id="RingBuilderCompleteEngraving"
                    type="text"
                    maxlength="${engravingMaxChars}"
                    data-ring-builder-complete-engraving
                    value="${escapeHtml(engravingValue)}"
                    placeholder="Engraving Text..."
                  >
                  <span class="rb-complete-engraving-block__count" data-ring-builder-complete-engraving-count>${engravingValue.length}/${engravingMaxChars} characters</span>
                </div>

                <div class="rb-complete-checkout-block">
                  <div class="rb-complete-total-row">
                    <span>Total Price</span>
                    <strong>${formatMoney(totalPrice)}</strong>
                  </div>

                  <button type="button" class="rb-complete-purchase-btn" id="CompleteRingAddToCart">Complete Purchase</button>
                  <div class="text-danger font-weight-bold" id="CheckoutErrorMessage" style="display: none;"></div>

                  <div class="rb-complete-delivery-row">
                    ${truckIconSvg}
                    <span>${escapeHtml(deliveryText)} <span class="rb-complete-delivery-row__date">${escapeHtml(deliveryRange)}</span></span>
                  </div>
                </div>

                <div class="rb-complete-section">
                  <h2 class="rb-complete-section__title">Know Your Setting</h2>
                  <div class="rb-complete-setting-board">
                    ${(() => {
                      const hasWidth = !!(setting.bandWidth && String(setting.bandWidth).trim());
                      const hasProng = !!(setting.prongType && String(setting.prongType).trim());
                      const widthCell = hasWidth
                        ? settingSpecCell('Width', formatBandWidthDisplay(setting.bandWidth), 'setting', 'Measured at the base of the ring', 'Measured at the base of the ring')
                        : '';
                      const prongCell = hasProng
                        ? settingSpecCell('Prong Type', formatProngDisplay(setting.prongType), 'setting', 'The style of metal claws holding your diamond', '')
                        : '';
                      if (!widthCell && !prongCell) return '';
                      if (widthCell && prongCell) {
                        return '<div class="rb-complete-setting-board__row rb-complete-setting-board__row--split">' +
                          widthCell + prongCell +
                          '</div>';
                      }
                      return '<div class="rb-complete-setting-board__row">' +
                        (widthCell || prongCell) +
                        '</div>';
                    })()}
                    <div class="rb-complete-setting-board__row">
                      ${settingSpecCell('Ring Size', formatRingSizeLabel(setting.ringSize) || '-', 'setting', 'UK ring size for your selected band', '')}
                    </div>
                    <div class="rb-complete-setting-board__row">
                      ${settingSpecCell('Metal', getMetalLabel(setting), 'setting', 'Metal type and karat for your setting', '')}
                    </div>
                  </div>
                </div>

                ${productInfoAccordion('Ring Details', ringDetailsPanel, '', true)}
                ${productInfoAccordion(shippingTitle, shippingContent)}

              </div>
            </div>
          </div>
        `;

        container.querySelectorAll('[data-ring-builder-complete-change]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            const target = link.getAttribute('data-ring-builder-complete-change');
            activateStep(getLogicalStepForContent(target));
          });
        });

        const engravingField = container.querySelector('[data-ring-builder-complete-engraving]');
        const engravingCount = container.querySelector('[data-ring-builder-complete-engraving-count]');
        if (engravingField && engravingCount) {
          const updateEngravingCount = function () {
            engravingCount.textContent = engravingField.value.length + '/' + engravingMaxChars + ' characters';
          };
          const persistEngraving = function () {
            setting.engraving = engravingField.value.trim();
            localStorage.setItem('ringBuilderSelectedSetting', JSON.stringify(setting));
          };
          engravingField.addEventListener('input', function () {
            updateEngravingCount();
            persistEngraving();
          });
          updateEngravingCount();
        }

        const addToCartBtn = container.querySelector('#CompleteRingAddToCart');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const engravingField = container.querySelector('[data-ring-builder-complete-engraving]');
            if (engravingField) {
              setting.engraving = engravingField.value.trim();
              localStorage.setItem('ringBuilderSelectedSetting', JSON.stringify(setting));
            }
            addBundleToCart(setting, diamond, addToCartBtn);
          });
        }

        bindCompleteGallerySticky(container);
      };

      const NIVODA_LIVE_PROXY_BASE = 'https://diamondsforeveryone.com.au/apps/nivoda';

      const getProductSyncBaseUrl = function () {
        const syncBase = root.getAttribute('data-nivoda-product-sync-base');
        let base = syncBase ? syncBase.replace(/\/+$/, '') : '';
        if (/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(base)) {
          return NIVODA_LIVE_PROXY_BASE;
        }
        return base || NIVODA_LIVE_PROXY_BASE;
      };

      const getProxyBaseUrl = function () {
        return getProductSyncBaseUrl();
      };

      const postCartItems = function (items, button, originalText, errorDiv, onSuccess) {
        return fetch('/cart/add.js?_fd=0', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: items }),
        }).then(function (response) {
          return response.text().then(function (text) {
            var payload = {};
            if (text) {
              try {
                payload = JSON.parse(text);
              } catch (parseError) {}
            }
            if (!response.ok) {
              throw new Error(
                (payload && (payload.description || payload.message)) ||
                  'Failed to add items to cart. Please try again.'
              );
            }
            return payload;
          });
        }).then(function () {
          if (typeof onSuccess === 'function') onSuccess();
        }).catch(function (error) {
          if (button) {
            button.disabled = false;
            button.innerHTML = originalText;
          }
          if (errorDiv) {
            errorDiv.textContent = error.message || 'Failed to add items to cart. Please try again.';
            errorDiv.style.display = 'block';
          }
          throw error;
        });
      };

      const ensureDiamondVariantForCart = function (diamond, builderId) {
        if (window.RingBuilderDiamonds && typeof window.RingBuilderDiamonds.ensureDiamondForCart === 'function') {
          return window.RingBuilderDiamonds.ensureDiamondForCart(diamond, builderId);
        }

        const proxyBase = getProxyBaseUrl();
        if (!proxyBase) {
          return Promise.reject(new Error('Nivoda proxy URL is not configured.'));
        }

        return fetch(proxyBase + '/diamond/ensure-product', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            diamond: diamond,
            builder_id: builderId || '',
            margin: window.RingBuilderDiamondMargin
              ? window.RingBuilderDiamondMargin.getMarginPayload()
              : undefined,
          }),
        }).then(function (response) {
          return response.text().then(function (text) {
            var payload = {};
            if (text) {
              try {
                payload = JSON.parse(text);
              } catch (parseError) {
                throw new Error(
                  'Nivoda app proxy returned an invalid response. Restart start-dev.ps1, reinstall the app on this store, then hard-refresh the ring builder page.'
                );
              }
            }
            if (!response.ok) {
              throw new Error((payload && payload.error) || 'Unable to prepare diamond product.');
            }
            return payload;
          });
        });
      };

      const buildSettingCartProperties = function (setting, builderId) {
        return {
          'Ring Size': formatRingSizeLabel(setting.ringSize) || '',
          'Band Width': setting.bandWidth || '',
          'Prong Type': setting.prongType || '',
          'Customer Notes': setting.engraving || '',
          setting_sku: setting.productHandle || '',
          _builder_id: builderId
        };
      };

      const addBundleToCart = function (setting, diamond, button) {
        const placeholderDiamondVariantId = root.getAttribute('data-placeholder-diamond-variant-id');
        const errorDiv = button
          ? (button.closest('.rb-complete-pdp') || root).querySelector('#CheckoutErrorMessage')
          : root.querySelector('#CheckoutErrorMessage');

        if (errorDiv) errorDiv.style.display = 'none';
        const originalText = button.innerHTML;
        button.disabled = true;
        button.innerHTML = '<span class="loader-line" style="display: inline-block; width: 20px; height: 20px; border: 2px solid currentColor; border-top-color: transparent; border-radius: 50%; animation: spin 0.6s linear infinite; vertical-align: middle; margin-right: 8px;"></span> Preparing your ring...';

        const builderId = 'rb_' + Date.now();

        ensureDiamondVariantForCart(diamond, builderId)
          .then(function (ensureResult) {
            const diamondVariantId = parseInt(ensureResult.variantId, 10);
            if (!diamondVariantId) {
              throw new Error('Diamond variant was not returned from the server.');
            }

            const settingVariantId = parseInt(setting.variantId, 10);
            if (!settingVariantId) {
              throw new Error('Setting variant is missing. Please go back to Step 1 and re-select your ring.');
            }

            const diamondProperties = ensureResult.properties || (
              window.RingBuilderDiamonds && typeof window.RingBuilderDiamonds.buildDiamondCartProperties === 'function'
                ? window.RingBuilderDiamonds.buildDiamondCartProperties(diamond, builderId)
                : { _builder_id: builderId, _price: diamond.price }
            );
            if (ensureResult.productId) {
              diamondProperties._product_id = String(ensureResult.productId);
            }

            const items = [
              {
                id: settingVariantId,
                quantity: 1,
                properties: buildSettingCartProperties(setting, builderId)
              },
              {
                id: diamondVariantId,
                quantity: 1,
                properties: diamondProperties
              }
            ];

            button.innerHTML = '<span class="loader-line" style="display: inline-block; width: 20px; height: 20px; border: 2px solid currentColor; border-top-color: transparent; border-radius: 50%; animation: spin 0.6s linear infinite; vertical-align: middle; margin-right: 8px;"></span> Adding...';

            return postCartItems(items, button, originalText, errorDiv, function () {
              if (window.RingBuilderCartCleanup && ensureResult.productId) {
                window.RingBuilderCartCleanup.trackProductId(ensureResult.productId);
              }

              localStorage.removeItem('ringBuilderSelectedSetting');
              localStorage.removeItem('ringBuilderSelectedDiamond');
              localStorage.removeItem('ringBuilderCurrentStep');

              if (window.theme && window.theme.miniCart) {
                if (typeof window.theme.miniCart.updateElements === 'function') {
                  window.theme.miniCart.updateElements();
                }
                if (typeof window.theme.miniCart.generateCart === 'function') {
                  window.theme.miniCart.generateCart();
                }
              }
              window.location.href = '/cart?_fd=0';
            });
          })
          .catch(function (error) {
            button.disabled = false;
            button.innerHTML = originalText;
            const message = (error && error.message) || 'Unable to prepare diamond for cart.';
            if (errorDiv) {
              errorDiv.textContent = message;
              errorDiv.style.display = 'block';
            }

            const isShopifyConfigError =
              /invalid api key|access token|session missing|missing required shopify scopes|reinstall|not configured|shopify admin/i.test(
                message
              );
            const isAppProxyError =
              /invalid app proxy|proxy returned an invalid response|restart start-dev|not found|failed to fetch|network/i.test(
                message
              );

            if (isShopifyConfigError || isAppProxyError) {
              if (errorDiv) {
                errorDiv.textContent =
                  message +
                  ' Complete Purchase needs the Nivoda Product Sync app running (start-dev.ps1 in nivoda-product-sync) and installed on this store. Reinstall: open the install URL from the app terminal, then test /apps/nivoda/health in the browser.';
              }
              return;
            }

            if (!placeholderDiamondVariantId) return;

            const fallbackConfirmed = window.confirm(
              'Live diamond product setup is unavailable. Add using the placeholder diamond instead? Checkout price may not match the Nivoda price until Shopify is configured.'
            );
            if (!fallbackConfirmed) return;

            button.disabled = true;
            const fallbackProperties = window.RingBuilderDiamonds && typeof window.RingBuilderDiamonds.buildDiamondCartProperties === 'function'
              ? window.RingBuilderDiamonds.buildDiamondCartProperties(diamond, builderId)
              : { _builder_id: builderId, _price: diamond.price };

            postCartItems([
              {
                id: parseInt(setting.variantId, 10),
                quantity: 1,
                properties: buildSettingCartProperties(setting, builderId)
              },
              {
                id: parseInt(placeholderDiamondVariantId, 10),
                quantity: 1,
                properties: fallbackProperties
              }
            ], button, originalText, errorDiv, function () {
              localStorage.removeItem('ringBuilderSelectedSetting');
              localStorage.removeItem('ringBuilderSelectedDiamond');
              localStorage.removeItem('ringBuilderCurrentStep');
              window.location.href = '/cart?_fd=0';
            });
          });
      };

      // Change Button Listeners
      if (stepperChangeBtn) {
        stepperChangeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (stepperChangeBtn.textContent.trim() === 'Change') {
            localStorage.removeItem('ringBuilderSelectedSetting');
          }
          openStepContent('setting');
        });
      }

      if (stepperChangeDiamondBtn) {
        stepperChangeDiamondBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (stepperChangeDiamondBtn.textContent.trim() === 'Change') {
            localStorage.removeItem('ringBuilderSelectedDiamond');
          }
          openStepContent('diamond');
        });
      }

      // Step Navigation Button Click Listeners
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          const stepTarget = button.getAttribute('data-step-target');
          activateStep(stepTarget);
        });
      });

      // Listen to events from diamond selector
      document.addEventListener('ring-builder:diamond-selected', function () {
        if (localStorage.getItem('ringBuilderSelectedSetting')) {
          navigateToContent('complete');
        } else {
          setPresentation(FLOW_DIAMOND_FIRST);
          navigateToContent('setting');
        }

        const stepperElement = root.querySelector('[data-ring-builder-stepper]');
        if (stepperElement) {
          stepperElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });



      // Back to settings list button click handler
      document.addEventListener('click', function(e) {
        const backBtn = e.target.closest('#BackToBrowseSettingsBtn');
        if (!backBtn) return;

        e.preventDefault();

        const browsePanel = root.querySelector('[data-ring-builder-browse]');
        if (browsePanel) browsePanel.hidden = false;

        const featuredPanel = root.querySelector('[data-ring-builder-featured]');
        const detailPanel = root.querySelector('[data-ring-builder-featured-detail]');
        if (featuredPanel) featuredPanel.hidden = true;
        if (detailPanel) detailPanel.hidden = true;

        if (window.RingBuilderQuickview && typeof window.RingBuilderQuickview.reset === 'function') {
          window.RingBuilderQuickview.reset();
        }
      });

      // Listen to setting selection completed event
      document.addEventListener('ring-builder:setting-selected', function (e) {
        const detail = e.detail;

        const browsePanel = root.querySelector('[data-ring-builder-browse]');
        if (browsePanel) browsePanel.hidden = false;

        const featuredPanel = root.querySelector('[data-ring-builder-featured]');
        const detailPanel = root.querySelector('[data-ring-builder-featured-detail]');
        if (featuredPanel) featuredPanel.hidden = true;
        if (detailPanel) detailPanel.hidden = true;

        if (window.RingBuilderQuickview && typeof window.RingBuilderQuickview.reset === 'function') {
          window.RingBuilderQuickview.reset();
        }

        // Keep diamond-first if a diamond was already chosen; otherwise setting-first.
        if (!localStorage.getItem('ringBuilderSelectedDiamond')) {
          setPresentation(FLOW_SETTING_FIRST);
        }

        // Move to diamond or complete step
        if (localStorage.getItem('ringBuilderSelectedDiamond')) {
          navigateToContent('complete');
        } else {
          navigateToContent('diamond');
        }

        // Scroll to stepper
        const stepperElement = root.querySelector('[data-ring-builder-stepper]');
        if (stepperElement) {
          stepperElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // Browser Back/Forward navigation sync
      window.addEventListener('popstate', function () {
        const popParams = new URLSearchParams(window.location.search);
        const flowFromPath = getFlowFromPath();
        const flowParam = popParams.get('flow');
        let nextFlow = flowFromPath || flowParam;
        if (nextFlow !== FLOW_DIAMOND_FIRST && nextFlow !== FLOW_SETTING_FIRST) {
          if (urlHasDiamondEntryParams(popParams)) nextFlow = FLOW_DIAMOND_FIRST;
        }
        if (nextFlow === FLOW_DIAMOND_FIRST || nextFlow === FLOW_SETTING_FIRST) {
          setPresentation(nextFlow);
        }
        const step = popParams.get('step') || '1';
        activateStep(step);
      });

      const urlParams = new URLSearchParams(window.location.search);
      const flowFromPath = getFlowFromPath();
      const flowParam = urlParams.get('flow');
      const hasDiamondEntry = urlHasDiamondEntryParams(urlParams);
      // Prefer URL intent (survives after Shopify strips /diamonds|/settings).
      let resolvedFlow = flowFromPath || flowParam;
      if (resolvedFlow !== FLOW_DIAMOND_FIRST && resolvedFlow !== FLOW_SETTING_FIRST) {
        if (hasDiamondEntry) resolvedFlow = FLOW_DIAMOND_FIRST;
      }

      const hasExplicitEntryIntent = !!(
        flowFromPath ||
        flowParam === FLOW_DIAMOND_FIRST ||
        flowParam === FLOW_SETTING_FIRST ||
        hasDiamondEntry
      );

      let stepParam = urlParams.get('step');
      // Nav deep links omit step — do not resume a stale mid-flow localStorage step.
      if (!stepParam) {
        stepParam = hasExplicitEntryIntent
          ? '1'
          : localStorage.getItem('ringBuilderCurrentStep') || '1';
      }

      if (resolvedFlow === FLOW_DIAMOND_FIRST || resolvedFlow === FLOW_SETTING_FIRST) {
        setPresentation(resolvedFlow);
      } else {
        setPresentation(inferFlowFromSelections());
      }

      wireRingBuilderProductCards();
      activateStep(stepParam);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nivoda_diamonds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.RingBuilderDiamonds && typeof window.RingBuilderDiamonds.initStep2 === 'function') {
      window.RingBuilderDiamonds.initStep2();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nivoda_gemstones"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.RingBuilderGemstones && typeof window.RingBuilderGemstones.init === 'function') {
      window.RingBuilderGemstones.init();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              theme.tooltip.load();
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  class productPairsRight extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('HTTP error! Status: '.concat(response.status));
          }
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement('div');
          frag.appendChild(fetchedContent);
          fetchedContent.innerHTML = response;

          var replacementContent = fetchedContent.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
          if (replacementContent) {
            this.innerHTML = replacementContent.innerHTML;
          }
        });
    }
  }

  customElements.define('product-pairsright', productPairsRight);

  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.checkAgreement();
    }

    handleClick(event) {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      const checkoutButton = this.querySelector('.product-form__buynow');

      if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
        if (agreeCheckbox.checked) {
          checkoutButton.classList.remove('disabled');
        } else {
          checkoutButton.classList.add('disabled');
        }
      }
    }
    checkAgreement() {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      return agreeCheckbox.checked;
    }
  }

  customElements.define('buy-now', BuyNow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
